<!--
 * @Author: ZS
 * @Date: 2020-06-23 15:18:35
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 17:58:45
 * @Description: file content
-->
<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-23 10:15:37
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <h3 class="myTit clearfix">
      <span>评价审核</span>
      <ul class="clearfix noselect">
        <li :class="{active:titIndex === 0}" @click="titChange(0)">待审核</li>
        <li :class="{active:titIndex === 1}" @click="titChange(1)">已通过</li>
        <li :class="{active:titIndex === 2}" @click="titChange(2)">未通过</li>
      </ul>
    </h3>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="xuhao" width="60" label="序号" align="center">
      </el-table-column>
      <el-table-column label="事项名称" prop="guidelineName">
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionSuggestion" label="评价内容" align="center">
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionSatisfaction" label="评价星级" width="180" align="center">
        <template slot-scope="scope">
          <el-rate v-model="scope.row.pcHandlingGuidelineSuggestionSatisfaction" disabled>
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column prop="pcHandlingGuidelineSuggestionTime" label="评价时间" width="160" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="130">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" class="detailBtn"
            v-if="type === 1||type===2">查看
          </el-button>
          <el-button size="mini" type="danger" @click="inquiryOpen(scope.$index, scope.row)" class="advisoryBtn"
            v-if="type === 0">
            审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block fenyeBox">
      <el-pagination @size-change="handleSizeChange0" @current-change="handleCurrentChange0"
        :current-page="fenye.currentPage0" :page-sizes="[10, 20, 30, 40]" :page-size="fenye.pageSize0"
        layout="total, sizes, prev, pager, next, jumper" :total="fenye.totalNum0" v-if="titIndex == 0">
      </el-pagination>
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
        :current-page="fenye.currentPage1" :page-sizes="[10, 20, 30, 40]" :page-size="fenye.pageSize1"
        layout="total, sizes, prev, pager, next, jumper" :total="fenye.totalNum1" v-if="titIndex == 1">
      </el-pagination>
      <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
        :current-page="fenye.currentPage2" :page-sizes="[10, 20, 30, 40]" :page-size="fenye.pageSize2"
        layout="total, sizes, prev, pager, next, jumper" :total="fenye.totalNum2" v-if="titIndex == 2">
      </el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-dialog title="评价详情" :visible.sync="dialogVisible" width="550px" class="dialog">
      <div style="padding:0 15px;font-size:16px" class="dialog">
        <h4 class="tit">评价信息</h4>
        <p><span>评价分数：</span>
          <el-rate v-model="pjScore" disabled show-text :texts="texts"
            style="display:inline-block">
          </el-rate>
        </p>
        <p><span>评价内容：</span>{{pjContent}}</p>
        <p><span>评价人：</span>{{pjPerson}}</p>
        <p><span>评价时间：</span>{{pjTime}}</p>
        <div v-if="type != 0">
           <h4 class="tit">审核信息</h4>
          <ul class="shxx">
            <li><i>审核状态：</i><span style="color:#008000" v-if="type===1">已通过</span><span style="color:#FF0000"
                v-if="type===2">未通过</span>
            </li>
            <li><i>审核人：</i>{{shr}}</li>
            <li><i>审核意见：</i>{{shyj}}</li>
            <li><i>审核时间：</i>{{shsj}}</li>
          </ul>
        </div>
        <div v-if="type === 0">
          <h4 class="tit">审核意见</h4>
          <el-input type="textarea" placeholder="未通过的评价填写审核意见" v-model="shContent"
            style="margin-bottom: 20px; min-height:60px">
          </el-input>
        </div>
      </div>
       <div slot="footer" class="dialog-footer">
         <template v-if=" titIndex == 0">
            <el-button @click="sh(1)" class="tjBtn">通过</el-button>
            <el-button type="warning" @click="sh(2)">未通过</el-button>
         </template>
         <el-button  @click="dialogVisible = false">关闭</el-button>
       </div>
    </el-dialog>

  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        tableData: [],
        value: 4.7,
        fenye: {
          currentPage0: 1,
          pageSize0: 10,
          totalNum0: 0,
          currentPage1: 1,
          pageSize1: 10,
          totalNum1: 0,
          currentPage2: 1,
          pageSize2: 10,
          totalNum2: 0,
        },
        dialogVisible: false,
        currentPage4: 1,
        titIndex: 0,
        pjContent: '',
        pjTime: '',
        pjPerson: '',
        pjScore: 0,
        type: 0,
        shr: '',
        shyj: '',
        shsj: '',
        shContent: '',
        id: '',
        newMsg: 0,
        texts:['非常不满','不满','一般','满意','非常满意'],
      }
    },
    mounted() {
      this.getPj()
    },
    methods: {
      handleEdit(index, row) {
        this.pjContent = row.pcHandlingGuidelineSuggestionSuggestion,
          this.pjTime = row.pcHandlingGuidelineSuggestionTime,
          this.pjPerson = row.pjr,
          this.pjScore = row.pcHandlingGuidelineSuggestionSatisfaction,
          this.shr = row.shr
        if (this.type === 1 || this.type === 2) {
          this.shsj = this.publicJs.renderTime(row.portalPcGuidelineSuggestionApproval.pcGuidelineSuggestionApprovalTime)
          this.shyj = row.portalPcGuidelineSuggestionApproval.pcGuidelineSuggestionApprovalStatement
        }
        this.dialogVisible = true
      },
      inquiryOpen(index, row) {
        this.shContent = "";
        this.id = row.pcHandlingGuidelineSuggestionId
        this.pjContent = row.pcHandlingGuidelineSuggestionSuggestion,
          this.pjTime = row.pcHandlingGuidelineSuggestionTime,
          this.pjPerson = row.pjr,
          this.pjScore = row.pcHandlingGuidelineSuggestionSatisfaction,
          this.shr = row.shr
        this.dialogVisible = true
      },
      handleSizeChange0(val) {
        this.fenye.pageSize0 = val
        // console.log(`每页 ${val} 条`);
        this.getPj()
      },
      handleCurrentChange0(val) {
        this.fenye.currentPage0 = val
        // console.log(`当前页: ${val}`);
        this.getPj()
      },
      handleSizeChange1(val) {
        this.fenye.pageSize1 = val
        // console.log(`每页 ${val} 条`);
        this.getPj()
      },
      handleCurrentChange1(val) {
        this.fenye.currentPage1 = val
        // console.log(`当前页: ${val}`);
        this.getPj()
      },
      handleSizeChange2(val) {
        this.fenye.pageSize2 = val
        // console.log(`每页 ${val} 条`);
        this.getPj()
      },
      handleCurrentChange2(val) {
        this.fenye.currentPage2 = val
        // console.log(`当前页: ${val}`);
        this.getPj()
      },
      titChange(idx) {
        this.titIndex = idx
        this.type = idx
        this.getPj()
      },
      getPj() {
        let sendData
        if (this.titIndex == 0) {
          sendData = qs.stringify({
            type: this.type,
            pageNum: this.fenye.currentPage0,
            pageSize: this.fenye.pageSize0,
            memberId: this.$store.state.userId
          })
        } else if (this.titIndex == 1) {
          sendData = qs.stringify({
            type: this.type,
            pageNum: this.fenye.currentPage1,
            pageSize: this.fenye.pageSize1,
            memberId: this.$store.state.userId
          })
        } else if (this.titIndex == 2) {
          sendData = qs.stringify({
            type: this.type,
            pageNum: this.fenye.currentPage2,
            pageSize: this.fenye.pageSize2,
            memberId: this.$store.state.userId
          })
        }
        this.ywtbRequest('/portal-ywtb/web/guidelineSuggestion/listSuggestionByCondition', sendData).then(res => {
          var data = res.dataList
          if (this.titIndex == 0) {
            this.fenye.totalNum0 = res.count
            // 更新外部数据
            this.$parent.changeGztBadge(6, res.count || 0);
          } else if (this.titIndex == 1) {
            this.fenye.totalNum1 = res.count
          } else if (this.titIndex == 2) {
            this.fenye.totalNum2 = res.count
          }
          if (this.type === 0) {
            this.$emit('newMsg', res.count)
          }
          for (let i = 0; i < data.length; i++) {
            data[i].xuhao = i + 1;
            data[i].pcHandlingGuidelineSuggestionTime = this.publicJs.renderTime(data[i]
              .pcHandlingGuidelineSuggestionTime);
          }
          this.tableData = res.dataList
        })
      },
      sh(state) {
        let sendData = qs.stringify({
          pcGuidelineSuggestionApprovalSuggestionId: this.id,
          pcGuidelineSuggestionApprovalStatement: this.shContent,
          pcGuidelineSuggestionApprovalApprover: this.$store.state.userId,
          pcHandlingGuidelineSuggestionState: state
        })
        if ((!this.shContent || String(this.shContent).trim() === "") && state === 2) {
          this.$message({
            message: '请输入审核意见',
            type: 'warning'
          });
          return;
        }
        this.ywtbRequest('/portal-ywtb/web/guidelineSuggestion/saveSuggestionByCondition', sendData).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.getPj();
        })
      },
    }
  }

</script>

<style scoped>
  .myTit {
    /* line-height: 42px; */
    padding: 30px 0 15px 0;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .myTit>span {
    float: left;
    color: #091B28;
    font-size: 22px;
    font-family: PingFang SC;
  }

  .myTit>ul {
    float: right;
  }

  .myTit>ul>li {
    float: left;
    width: 84px;
    height: 34px;
    background: rgba(53, 139, 247, 0.1);
    color: #687986;
    line-height: 34px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
  }

  .myTit>ul>li.active {
    background-color: #358BF7;
    color: #fff;
  }

  .detailBtn,
  .advisoryBtn {
    width: 56px;
    height: 27px;
    border-radius: 14px;
    padding: 0;
    text-align: center;
    font-size: 13px;
    color: #fff;
    border: none;
  }

  .detailBtn {
    background: rgba(255, 165, 71, 1);

  }

  .detailBtn:hover, .detailBtn:focus {
    background: rgba(255, 165, 71, 0.8);
    color: #fff;
  }

  .advisoryBtn {
    background: rgba(53, 139, 247, 1);
  }

  .advisoryBtn:hover, .advisoryBtn:focus {
    background: rgba(53, 139, 247, 0.8);
    color: #fff;
  }

  .fenyeBox {
    text-align: center;
    padding-top: 20px;
  }

  .newBg {
    display: inline-block;
    width: 55px;
    height: 23px;
    line-height: 22px;
    background: url(../../../../static/images/newBg.png) no-repeat 0px 0px;
    text-align: center;
    color: #fff;
    margin-left: 6px;
  }

  .dialog p {
    line-height: 36px;
  }

  .dialog /deep/ .el-rate__icon {
    font-size: 24px;
  }

  .shxx li {
    line-height: 36px;
    font-size: 14px;
  }
  .shxx li>i{
    display: inline-block;
    width: 70px;
    text-align: right;
    color: #999;
    color: #8C8C8C;
  }
.dialog p {
line-height: 36px;
font-size: 14px;
}
.dialog p >span {
display: inline-block;
width: 70px;
text-align: right;
color: #8C8C8C;
}
.dialog /deep/ .el-rate__icon {
font-size: 24px;
}

.dialog /deep/ .el-dialog__title {
color: #262626;
font-size: 18px;
font-weight: 700;
}

.dialog /deep/ .el-textarea__inner {
resize: none;
}

.dialog /deep/ .el-dialog__body {
padding: 25px 40px 5px 30px;
}

.dialog /deep/ .el-dialog__footer {
text-align: center;
padding: 15px 0 30px 0;
}

.dialog /deep/ .el-button {
border-radius: 2px;
}

.dialog .tjBtn {
background: rgba(68, 110, 255, 1);
color: #fff;
border: none;
}

.dialog .tjBtn:hover {
background: rgb(50, 93, 250);
}
h4.tit {
color: #262626;
font-size: 16px;
font-weight: 700;
padding-left: 10px;
border-left: 4px solid #446EFF;
margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/user/EvaluationReview.vue